(function ($){
    $.noConflict();
    $(document).ready(function () {

        $("#mobile-drawer-scroll-up, #mobile-drawer-scroll-down").on("click", function(event) {
            console.log("click!");
            let scrollTop = $(".header-md-container").scrollTop();
            console.log(scrollTop);
            console.log(event);
            if (event.currentTarget.id === 'mobile-drawer-scroll-up' ) {
                $(".header-md-container").scrollTop(scrollTop - 75);
            } else {
                $(".header-md-container").scrollTop(scrollTop + 75);
            }
            
        });
        $(".header-md-container").scroll(function() {
            clearTimeout($.data(this, 'scrollTimer'));
            $.data(this, 'scrollTimer', setTimeout(function() {
                console.log($(".header-md-container").offset().top);
                if ($(".header-md-container").scrollTop() == 0) {
                    
                } else {
                }

                if ($(".header-md-container")[0].scrollTop + $(".header-md-container")[0].offsetHeight>= $(".header-md-container")[0].scrollHeight ){
                 } else {
                 }
                
            }, 250));
        });

        $("#menu-drawer ul li.dropdown-item").click(function(e){
            $(this).find(".dropdown-item-menu").slideToggle();
            $(this).toggleClass("active");
        });
        $("#menu-drawer ul li:has(ul), .slide-panel-inner-container ul li:has(ul)").addClass('subbed');
        $(".dropdown-item-menu li").click(function(e){
            $(this).find("ul.navigation-grand-child").slideToggle();
            $(this).find("span").toggleClass("open");
            e.stopPropagation();
        });

        // Slideout Menu
        function slideoutMenu(){
            // Slideout Open
            $('.site-header__slideout-menu').click(function (){
                $('.slideout-menu').show("slide", { direction: "left" }, 500);
            });
            // Slideout Items
            $('.slideout-item').each(function (){
                if ($(this).find(".navigation-child").children().length > 0) {
                    $(this).addClass("slideout-active");
                }
            });
            // Slideout Item Active
            $(".slideout-active").click(function() {
                $(this).find(".slideout-top-item").toggleClass("open");
                $(this).find(".navigation-child").slideToggle();
                $(this).find(".slideout-down-arrow").toggleClass("rotate");
            });
            // Slideout Close
            $('.slideout-menu-close').click(function (){
                $('.slideout-menu').hide("slide", { direction: "left" }, 500);
                $(".slideout-top-item").removeClass("open");
                $(".navigation-child").hide();
                $(".slideout-down-arrow").removeClass("rotate");
            });
        }  

        slideoutMenu();

        // Mega Menu
        function megaMenu(){
            $('ul.header__submenu').each(function (){
                if ($(this).children().length >= 10) {
                    $(this).addClass("plus");
                    $(this).parent('li').addClass("extended-list");
                } else {
                    $(this).removeClass("plus");
                    $(this).parent('li').removeClass("extended-list");
                }
            });

            $("li.mega-menu-item").each(function(){
                if ($(this, "ul.header__submenu").find("li").length == 0 ){
                    $(this).addClass("blank");
                }
            });
        }
        
        megaMenu();

        // Slide-Panel-Menu
        function slidePanelMenu(){
            $('ul li.slide-panel-nav-main-item:has(ul)').addClass('has-menu');

            //Handle pushing below universal header if needed using intersection observer
            if ($('.slide-panel-menu').data('avoid-universal-header') == true) {
                let universalHeaderHeight = $("#shopify-section-universal-header").height();
                $(".slide-panel-menu").css("top", universalHeaderHeight + "px");
                let options = {
                    rootMargin: '0px'
                  }
                  let callback = (entries) => {
                    let intersectionRatio = entries[0].intersectionRatio;
                    let newPushHeight = universalHeaderHeight * intersectionRatio;
                    $(".slide-panel-menu").css("top", newPushHeight + "px");
                    $(".slide-panel-menu.active .overlay-slide-panel-container").css("height", "calc(100vh - " + newPushHeight + "px");
                    
                }
                let target = document.querySelector('#shopify-section-universal-header');
                  let observer = new IntersectionObserver(callback, options);
                  observer.observe(target);
                  $(window).on("scroll", function() {
                    observer.unobserve(target);
                    observer.observe(target);
                  })
            }
            

            //Open slideout Menu
            $('.site-header__slideout-menu, .slide-panel-nav-main-item i').click(function(){
                window.postMessage({ type: 'navigation', action: "open", menu_type: 'slide-panel' }, '*');
                $(this).addClass('open');
                $('.site-header__slideout-close').addClass('active');
                if ($('.overlay-slide-panel-container').length > 0) {
                    $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar').addClass('active');
                    $('.overlay-slide-panel-container').animate({
                        left: '0px'
                    }, 250, function() {
                    });
                } else {
                    $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar').addClass('active');
                }
                
               
            });

            /*** Menu Animations ***/
            $('li.slide-panel-nav-main-item').click(function(e){
                
                $("ul.navigation-child", this).slideToggle();
                
                $(this).toggleClass('active');
                e.stopPropagation();
            });

            /*** Slide Panel Child Animation ***/
            $('li.nav-slide-child-header').click(function(){
                $("ul.navigation-child", this).toggle("slide", { direction: "right" }, 500);
                $('ul.navigation-child').removeClass('active');
            });
            /*** Slide Panel Grand-Child Animation ***/
            $('.slide-panel-inner-container li.slide-panel-nav-child-item.subbed').click(function(e){
                
                $(this).find("ul.navigation-grand-child").slideToggle();
                $(this).find("span").toggleClass("open");
                
                e.stopPropagation();
            });

            $('li.nav-slide-grand-child-header').click(function(){
                $("ul.navigation-grand-child", this).toggle("slide", { direction: "right" }, 500);
                $('ul.navigation-grand-child').removeClass('active');
            });

            $('.slide-panel-close, .site-header__slideout-close').click(function(){
                window.postMessage({ type: 'navigation', action: "close", menu_type: 'slide-panel' }, '*');
                $('.site-header__slideout-menu').removeClass('open');
                if ($('.overlay-slide-panel-container').length > 0) {
                    let negativeWidth = "-100%";
                    if ($(window).width() >= 750) {
                        negativeWidth = $('.slide-panel-menu').data('negative-width');
                    }
                    $('.overlay-slide-panel-container').animate({
                        left: negativeWidth
                    }, 250, function() {
                        setTimeout(() => {
                            $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar, li.slide-panel-nav-main-item').removeClass('active');
                            $("ul.navigation-child").css("display", "none");
                          }, "300")

                    });
                } else {
                    $('.slide-panel-menu, .body-panel-content, .body-panel-content-sidebar, li.slide-panel-nav-main-item, .site-header__slideout-close').removeClass('active');
                    $("ul.navigation-child").css("display", "none");
                }
            });
            
        }

        slidePanelMenu();

        // Rerun Scripts in Shopify Theme Editor
        if (Shopify.designMode) {
            document.addEventListener('shopify:section:load', function(){
                slideoutMenu();
                megaMenu();
                slidePanelMenu();
            });
        }

    });
})(jQuery);